<template>
    <form class="box">
      <div class="columns is-multiline">
        <div class="column is-6">
          <span class="heading has-text-grey-dark">Provider full ID (e.g. MC-L1-U1-LC1-1, T1-L1-U1-LC1)</span>
          <div class="field">
            <bulma-input name="provider_full_id" :hasError="!vkLessonFormat(lesson.additionalInfo.provider_full_id)"  v-model="lesson.additionalInfo.provider_full_id" rules="required" placeholder='Provider full id'/>
            <transition name="fade-fast">
              <span v-show="!vkLessonFormat(lesson.additionalInfo.provider_full_id)" class="help is-danger">Wrong format</span>
            </transition>
            <span>Example: MC-L1-U1-LC1-1, T1-L1-U1-LC1,..</span>
          </div>
        </div>
        <div class="column is-6">
          <span class="heading has-text-grey-dark">Lesson Name</span>
          <div class="field">
            <bulma-input name="name" v-model="lesson.additionalInfo.name" rules="required" placeholder='Name'/>
          </div>
        </div>
        <div class="column is-6">
          <span class="heading has-text-grey-dark">Words (Vocabulary)</span>
          <div class="field">
            <bulma-input name="words" v-model="lesson.additionalInfo.words" rules="required" placeholder='Words'/>
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div v-for="(property, index) in lesson.additionalInfo" class="column is-6" v-if="!excludeProperties.includes(index)">
          <span class="heading has-text-grey-dark">{{snakeToCamelCase(index)}}</span>
          <div class="field">
            <textarea class="textarea" :name="index" v-model="lesson.additionalInfo[index]" rules="" :placeholder="snakeToCamelCase(index)"/>
          </div>
        </div>
      </div>

<!--      <additional-info :additionalInfo="lesson.additionalInfo" ></additional-info>-->
      <div class="columns is-multiline">
        <div class="column is-2">
          <loading-button v-bind:loading="loading" color="is-info" @click="save()">Save</loading-button>
        </div>
        <div class="column is-2 is-offset-8 is-pulled-right">
          <a href="javascript:history.go(-1)" class="button is-block">
            Back
          </a>
        </div>
      </div>
    </form>
</template>

<script>

  import AdditionalInfo from './AdditionalInfo.vue'

  export default {
    name: 'vk-lesson',
    components: {AdditionalInfo},
    props: {
      lessonForUpdate: { required: true },
      loading: { required: true, default: false },
    },
    data () {
      return {
        lesson: {},
        excludeProperties: ['id', 'name', 'words', 'provider_full_id'],
      }
    },
    created () {
      this.lesson = Object.assign({}, this.lessonForUpdate);
      if(!this.lesson.id){
          this.lesson.additionalInfo  = this.vkDefaultAdditionalInfo();
      }
  },
    methods: {
      save () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            if(!this.vkLessonFormat(this.lesson.additionalInfo.provider_full_id)){
                return;
            }
            this.$emit('save', this.lesson);
          }
        })
      }
    },
    watch: {

        lessonForUpdate: function (lesson) {
            this.lesson = Object.assign({}, lesson);
        }

    }

  }
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sb-lessons/components/VKLesson.vue